import React from 'react';

import {
  SpaceBarOutlined,
  TableRowsOutlined,
  VerticalAlignBottomOutlined,
  VerticalAlignCenterOutlined,
  VerticalAlignTopOutlined,
  ViewColumnOutlined,
} from '@mui/icons-material';
import { Link, ToggleButton, Tooltip } from '@mui/material';
import { COLUMNS_GAP_OPTIONS } from '@wp-block-builder/blocks/ColumnsSection/parsers';
import TooltipUnderline from '@wp-react/components/TooltipUnderline';

import createBlockInputSection from './helpers/createBlockInputSection';
import ColumnsLayoutInput from './special-inputs/ColumnsLayoutInput';
import HideSectionInput from './special-inputs/HideSectionInput';

const ColumnsSectionSidebarForm = createBlockInputSection({
  title: 'Columns block',
  inputs: [
    ColumnsLayoutInput,
    {
      type: 'toolbar-toggle',
      props: {
        label: (
          <TooltipUnderline title="Responsive styling is only supported on modern email clients. Click to learn more about email client support.">
            <Link color="inherit" href="https://www.usewaypoint.com/docs/email-client-support" target="_blank">
              Mobile columns layout
            </Link>
          </TooltipUnderline>
        ),
        name: 'mobileLayout',
        defaultValue: 'columns',
        children: [
          <ToggleButton key={0} value="columns">
            <Tooltip title="Keep columns side-by-side on mobile sized devices.">
              <ViewColumnOutlined fontSize="small" sx={{ width: '100%' }} />
            </Tooltip>
          </ToggleButton>,
          <ToggleButton key={1} value="stacked">
            <Tooltip title="Stack columns on mobile sized devices.">
              <TableRowsOutlined fontSize="small" sx={{ width: '100%' }} />
            </Tooltip>
          </ToggleButton>,
        ],
      },
    },
    {
      type: 'slider',
      props: {
        label: 'Columns gap',
        iconLabel: <SpaceBarOutlined sx={{ color: 'text.secondary' }} />,
        name: 'columnGap',
        units: 'px',
        max: COLUMNS_GAP_OPTIONS.max,
        min: COLUMNS_GAP_OPTIONS.min,
        step: 4,
        defaultValue: COLUMNS_GAP_OPTIONS.defaultValue,
        marks: true,
      },
    },
    {
      type: 'toolbar-toggle',
      props: {
        label: 'Alignment',
        name: 'contentAlignment',
        children: [
          <ToggleButton key={0} value="top">
            <VerticalAlignTopOutlined fontSize="small" />
          </ToggleButton>,
          <ToggleButton key={1} value="middle">
            <VerticalAlignCenterOutlined fontSize="small" />
          </ToggleButton>,
          <ToggleButton key={2} value="bottom">
            <VerticalAlignBottomOutlined fontSize="small" />
          </ToggleButton>,
        ],
      },
    },
    'backgroundColor',
    'padding',
    HideSectionInput,
  ],
});

export default ColumnsSectionSidebarForm;
